import React, { useState, useEffect, useRef } from "react";
import DatePicker, { setDefaultLocale, registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import "../index.css";
import { listado_seguros, reglamentoEstudio } from "../services/Matricula";
import { useSearchParams } from "react-router-dom"; 
import {
  listado_datos_personalesReturn,
  listado_empresas_seguro,
  listado_seguroDatos,
  listado_seguroPreliquidacion,
  update_paso,
  update_seguroEstudiante,
  validar_seguro_upch,
} from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import {
  KEY_DOLARES_PAYMENT,
  KEY_SAFETY_PAY,
  KEY_SOLES_PAYMENT,
  apiPasarelaSafetyPay,
  extensionArchivo,
  pasarelaPayment,
  pasarelaSafetyPay,
  tamanoArchivo,
} from "../config/constantes";
import SelectSeguro from "./Seguro/SelectSeguro/SelectSeguro";
import ModalPagoSeguro from "./Seguro/ModalPagoSeguro/ModalPagoSeguro";
import ModalSuccesErrorPasarela from "./Seguro/ModalSuccesErrorPasarela/ModalSuccesErrorPasarela";

registerLocale("es", es);

const Seguro = () => {
  const [toggles, setToggles] = useState(true);
  const [radioSeguros, setRadioSeguros] = useState("vacio");
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  const [empresaSeguro, setEmpresaSeguro] = useState(0);
  const [empresaSeguroArray, setEmpresaSeguroArray] = useState([]);
  const [errorEmpresaSeguroArrayDom, setErrorEmpresaSeguroArrayDom] =
    useState(false);
  const [numeroPoliza, setNumeroPoliza] = useState("");
  const [seleccionarArchivo, setSeleccionarArchivo] = useState("");
  const [aceptoTerminos, setAceptoTerminos] = useState(false);
  const [seguroNoCaduca, setSeguroNoCaduca] = useState(false);
  const [nombreArchivo, setNombreArchivo] = useState("");
  const [bases64, setBases64] = useState("");
  const [tipoArchivo, setTipoArchivo] = useState("");
  const [mensaje, setMensaje] = useState({});
  const [mensajeRadio, setMensajeRadio] = useState({});
  const { listadoEtiquetas, seleccionIdiomas, listadoIdiomas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const [idioma, setIdioma] = useState("es");
  const refSubirArchivo = useRef(null);
  const [especificarEmpresa, setEspecificarEmpresa] = useState("");
  const [cnombrearchivoAnterior, setCnombrearchivoAnterior] = useState("");
  const [option2, setOption2] = useState([]);
  const [statusDatosEstudianteSeguro, setStatusDatosEstudianteSeguro] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  let { obtenerDatosEstudiante } = useMatricula();
  let {
    obtenerEmpresasSegurosAccidentes,
    setPasoProcesoM,
    obtenerSegurosAccidentesEstudiante,
    setObtenerReglamentoEstudios,
    setPasoSegundaVistaProcesoM,
    setLoading,
    setCarritoHorario,
    setArchivoPeso,
    setObtenerEmpresasSegurosAccidentes,
    setErrorServices,
    setErrorCursoServices,
    setObtenerSegurosAccidentesEstudiante,
  } = useProcesoMatricula();

  const [validarSeguro, setValidarSeguro] = useState("");
  const { dciclo, fsistema, ndocidentidad } = obtenerDatosEstudiante;
  const [datosPersonales, setDatosPersonales] = useState([]);
  const [preliquidacion, setPreliquidacion] = useState({});

  const [show, setShow] = useState(false);
  const [showSecondary, setShowSecondary] = useState(false);
  const [showSecondaryPayment, setShowSecondaryPayment] = useState(false);
  const [seguroDatos, setSeguroDatos] = useState([]);
  const [requestPasarela, setRequestPasarela] = useState({
    show: false,
    type: "error",
    title: "",
    msg: "",
    preliquidacion: "",
    numeroTarjeta: "",
    monto: "",
    nombres: "",
    periodo: "",
    msgWarning: "",
  });

  const handleCloseModalRequest = () => {
    setRequestPasarela({
      show: false,
      type: "error",
      title: "",
      msg: "",
      preliquidacion: "",
      numeroTarjeta: "",
      monto: "",
    });
    validarSeguroUpch();
  };

  const handleShowModalRequest = (
    type,
    title = "",
    msg = "",
    preliquidacion = "",
    numeroTarjeta = "",
    monto = "",
    nombres = "",
    periodo = "",
    msgWarning = ""
  ) => {
    setRequestPasarela({
      show: true,
      type,
      title,
      msg,
      preliquidacion,
      numeroTarjeta,
      monto,
      nombres,
      periodo,
      msgWarning,
    });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSecondaryShow = async (typePasarela) => {
    try {
      console.log("[1] handleSecondaryShow iniciado");
      console.log("[1] Tipo de pasarela:", typePasarela);
      console.log("[1] Datos del estudiante:", obtenerDatosEstudiante);

      setLoading(true);

      const listSeguroDatos = await listado_seguroDatos(
        obtenerDatosEstudiante
      );

      console.log("[4] Resultado listado_seguroDatos:", listSeguroDatos);
      console.log("[4] ¿Es arreglo?:", Array.isArray(listSeguroDatos));
      console.log("[4] nmonto directo:", listSeguroDatos?.nmonto);
      console.log("[4] nmonto primer elemento:", listSeguroDatos?.[0]?.nmonto);

      setSeguroDatos(
        Array.isArray(listSeguroDatos)
          ? listSeguroDatos[0]
          : listSeguroDatos
      );

      if (typePasarela === pasarelaSafetyPay) {
        setShowSecondary(true);
      }

      if (typePasarela === pasarelaPayment) {
        const datosPersonales =
          await listado_datos_personalesReturn(
            obtenerDatosEstudiante,
            setLoading,
            true
          );

        // const preliquidacion =
        //   await listado_seguroPreliquidacion(
        //     obtenerDatosEstudiante,
        //     "ALI"
        //   );

        setDatosPersonales(datosPersonales);
        setPreliquidacion(preliquidacion);
        setShowSecondaryPayment(true);
      }
    } catch (error) {
      console.error("[ERROR handleSecondaryShow]", error);
      console.error("[ERROR mensaje]", error?.message);
      console.error("[ERROR respuesta]", error?.response);

      const modalErrorr = document.querySelector("#modalErr");

      if (modalErrorr) {
        modalErrorr.click();
        setErrorCursoServices(error?.message);
      }
    } finally {
      console.log("[FIN] handleSecondaryShow");
      setLoading(false);
    }
  };

  const handleSecondaryClose = (typePasarela) => {
    if (typePasarela === pasarelaSafetyPay) {
      setShowSecondary(false);
      validarSeguroUpch();
    }
    if (typePasarela === pasarelaPayment) {
      setShowSecondaryPayment(false);
    }
  };

  useEffect(() => {

    let datas = listadoIdiomas.map((e) => {
      if (e.cidioma == seleccionIdiomas) {
        return e.dsigla;
      }
    });

    let data = JSON.stringify(listadoIdiomas);
    setIdioma(String(datas).replace(",", ""));

  }, []);

  useEffect(() => {

    if (empresaSeguroArray.length <= 0) {
      setOption2(formaterListEmpresaSeguro().slice(0, 7));
    } else {

      const result = formaterListEmpresaSeguro().filter(
        (item) => item.code.toString() === empresaSeguroArray?.toString()
      );

      let resultSlice = result.slice(0, 7);
      setOption2(resultSlice);

    }
  }, [empresaSeguroArray]);

  useEffect(() => {
    if (empresaSeguro !== 8) {
      setEspecificarEmpresa("");
    }
  }, [empresaSeguro]);
  useEffect(() => {
    const { cinstitucion } = obtenerDatosEstudiante;

    if (cinstitucion) {
      // setValidarSeguro("1");
      validar_seguro_upch(obtenerDatosEstudiante, setValidarSeguro, setLoading);
    }
  }, [obtenerDatosEstudiante]);

  useEffect(() => {
    const { cinstitucion } = obtenerDatosEstudiante;

    if (cinstitucion) {
      if (validarSeguro === "0") {
        try {

          const metodoAync = async () => {
            await listado_empresas_seguro(
              obtenerDatosEstudiante,
              setObtenerEmpresasSegurosAccidentes,
              setLoading
            );

            await listado_seguros(
              obtenerDatosEstudiante,
              setObtenerSegurosAccidentesEstudiante,
              setLoading,
              setStatusDatosEstudianteSeguro
            );


          };
          metodoAync();

        } catch (error) {

        } finally {

        }
      }
    }
  }, [validarSeguro]);

  useEffect(() => {
    if (validarSeguro) {

      let seguro = validarSeguro === "1" ? "ConSeguro" : "SeguroPersonal";
      setRadioSeguros(seguro);
    }
  }, [validarSeguro]);
  let cambiarEstado = () => setToggles(!toggles);
  const soloLetras = (e) => {
    let regex = new RegExp("^[a-zA-Z0-9]*$");
    let key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (!regex.test(key)) {
      e.preventDefault();
      return false;
    }
  };

  useEffect(() => {

    setMensaje({});
    setMensajeRadio({});

    document.querySelector(".seleccione")?.classList.remove("ed-is-invalid");
    document.querySelector(".nroPoliza")?.classList.remove("ed-is-invalid");
    document.querySelector(".fecha")?.style.removeProperty("border-color");
    document.querySelector(".archivo")?.classList.remove("ed-is-invalid");


  }, [toggles]);

  useEffect(() => {
    if (radioSeguros == "ConSeguro") {
      setFechaVencimiento("");
      setEmpresaSeguro(0);
      setEmpresaSeguroArray([]);
      setNumeroPoliza(0);
      setSeleccionarArchivo("");
      setNombreArchivo("");
      setBases64("");
      setAceptoTerminos(false);
      setMensaje({});
      setSeguroNoCaduca(false);

    }
    setMensajeRadio({});
    document.querySelector(".seleccione")?.classList.remove("ed-is-invalid");
    document.querySelector(".nroPoliza")?.classList.remove("ed-is-invalid");
    document.querySelector(".fecha")?.style.removeProperty("border-color");
    document.querySelector(".archivo")?.classList.remove("ed-is-invalid");
  }, [radioSeguros]);

  useEffect(() => {
    setFechaVencimiento("");
  }, [seguroNoCaduca]);

  let {
    acepto,
    cseguro,
    darchivo,
    dnombrearchivo,
    fseguro,
    npoliza,
    ntipo,
    id_seguro,
    empresa_especificar,
  } = obtenerSegurosAccidentesEstudiante || {};

  useEffect(() => {

    let dataObject = obtenerSegurosAccidentesEstudiante == null ? {} : obtenerSegurosAccidentesEstudiante;
    if (Object.keys(dataObject).length > 0) {
      // if (fseguro) {
      let seguro =
        ntipo == 3 ? "SeguroPersonal" : ntipo == 1 ? "ConSeguro" : "vacio";

      setEspecificarEmpresa(empresa_especificar);

      setNumeroPoliza(npoliza);

      if (dnombrearchivo !== null || dnombrearchivo !== undefined) {
        setNombreArchivo(dnombrearchivo);
      }

      if (darchivo !== null || darchivo !== undefined) {
        setBases64(darchivo);
      }

      setAceptoTerminos(acepto);


      if (cseguro !== null || cseguro !== "" || cseguro !== undefined) {
        setEmpresaSeguro(cseguro);
      }

      if (dnombrearchivo !== null || dnombrearchivo !== undefined) {
        setCnombrearchivoAnterior(dnombrearchivo);
      }

      if (fseguro) {
        setFechaVencimiento(new Date(fseguro));
        if (fseguro == null || fseguro.includes("0001-01-01T00:00:00")) {
          setSeguroNoCaduca(true);
        } else {
          setSeguroNoCaduca(false);
        }
      }

    }

  }, [obtenerSegurosAccidentesEstudiante]);

  useEffect(() => {
    let dataObject = obtenerSegurosAccidentesEstudiante == null ? {} : obtenerSegurosAccidentesEstudiante;
    if (Object.keys(dataObject).length > 0) {
      if (obtenerEmpresasSegurosAccidentes.length > 0) {
        let existeIdSegudo = obtenerEmpresasSegurosAccidentes.some((item) => item.id_empresa == cseguro)
        if (existeIdSegudo) {
          setEmpresaSeguroArray([cseguro]);
        }
      }
    }
  }, [obtenerSegurosAccidentesEstudiante, obtenerEmpresasSegurosAccidentes])

  const validarSeguroUpch = () => {
    const { cinstitucion } = obtenerDatosEstudiante;
    if (cinstitucion) {
      validar_seguro_upch(obtenerDatosEstudiante, setValidarSeguro, setLoading);
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  let formateoNombre = (name) => {
    let nombreFomat = "";
    if (String(name).length >= 30) {
      nombreFomat = String(name).slice(0, 30) + "..";
    } else {
      nombreFomat = name;
    }

    return nombreFomat;
  };

  const handleSubirArchivo = (e) => {
    let subirArchivo = refSubirArchivo.current.files[0];

    // tamanoArchivo
    let extensionesPermitidos = String(extensionArchivo)
      .toLowerCase()
      .split("|");
    let extensionArchivos = subirArchivo.name
      .replace(/\s/g, "")
      .toLowerCase()
      .split(".")
      .slice(-1);

    if (extensionesPermitidos.includes(extensionArchivos[0])) {
      if (subirArchivo.size <= tamanoArchivo) {
        getBase64(subirArchivo).then((data) => {
          setBases64(data);
        });

        if (extensionArchivos[0] != "") {
          setTipoArchivo(extensionArchivos[0]);

        } else {
          setTipoArchivo("Unknown");

        }

        if (subirArchivo.name != "") {
          let extension = subirArchivo.name.split(".").slice(-1);
          let fechaActual = new Date(`${fsistema}`);
          let NombreArchiv =
            (fechaActual.getFullYear() < 10
              ? "0" + fechaActual.getFullYear()
              : fechaActual.getFullYear()) +
            "" +
            (fechaActual.getMonth() + 1 < 10
              ? "0" + (fechaActual.getMonth() + 1)
              : fechaActual.getMonth() + 1) +
            "" +
            (fechaActual.getDate() < 10
              ? "0" + fechaActual.getDate()
              : fechaActual.getDate()) +
            "" +
            `_${ndocidentidad}_` +
            "" +
            (fechaActual.getHours() + 1 < 10
              ? "0" + (fechaActual.getHours() + 1)
              : fechaActual.getHours() + 1) +
            "" +
            (fechaActual.getMinutes() + 1 < 10
              ? "0" + (fechaActual.getMinutes() + 1)
              : fechaActual.getMinutes() + 1) +
            "" +
            (fechaActual.getSeconds() + 1 < 10
              ? "0" + (fechaActual.getSeconds() + 1)
              : fechaActual.getSeconds() + 1) +
            "." +
            extension;
          setNombreArchivo(NombreArchiv);
        }

        setSeleccionarArchivo(e.target.value);
      } else {
        refSubirArchivo.value = "";

        const tamanioEnMb = tamanoArchivo / 1000000;
        setArchivoPeso({
          title: "Tamaño máximo",
          text: `El tamaño máximo es ${Number(tamanioEnMb)} MB`,
        });
        document.querySelector("#bntPesoArchivoTipo")?.click();
      }
    } else {
      refSubirArchivo.value = "";
      setArchivoPeso({
        title: "Extensiones permitidas",
        text: `Solo se permiten archivos con extension ${extensionesPermitidos}`,
      });

      document.querySelector("#bntPesoArchivoTipo")?.click();

    }

  };

  const validarBtnTieneSeguro = async (e) => {
    e.preventDefault();

    let refSeleccione = document.querySelector(".seleccione");
    let refNroPoliza = document.querySelector(".nroPoliza");
    let refFecha = document.querySelector(".fecha");
    let refArchivo = document.querySelector(".archivo");
    let refEspecificaEmpresa = document.querySelector(".especificaEmpresas");

    let seguro =
      radioSeguros == "SeguroPersonal"
        ? 3
        : radioSeguros == "ConSeguro"
          ? 1
          : 0;

    if (radioSeguros == "SeguroPersonal") {
      let tengoSegurRefValidate = seguroNoCaduca
        ? false
        : fechaVencimiento == "" ||
          String(fechaVencimiento).includes("0001") ||
          fechaVencimiento == null
          ? true
          : false;

      /**Para pintar las cajas de rojo */
      empresaSeguroArray.length === 0
        ? setErrorEmpresaSeguroArrayDom(true)
        : setErrorEmpresaSeguroArrayDom(false);


      numeroPoliza == "" || (numeroPoliza == null && refNroPoliza)
        ? refNroPoliza.classList.add("ed-is-invalid")
        : refNroPoliza.classList.remove("ed-is-invalid");

      tengoSegurRefValidate && refFecha
        ? (refFecha.style.borderColor = "#dc3545")
        : refFecha.style.removeProperty("border-color");

      nombreArchivo == "" ||
        nombreArchivo == null ||
        nombreArchivo == undefined ||
        bases64 == "" ||
        bases64 == undefined ||
        (bases64 == null && refArchivo)
        ? refArchivo.classList.add("ed-is-invalid")
        : refArchivo.classList.remove("ed-is-invalid");

      if (refEspecificaEmpresa) {


        empresaSeguroArray.includes(8) &&
          especificarEmpresa.length < 3 &&
          refEspecificaEmpresa
          ? refEspecificaEmpresa.classList.add("ed-is-invalid")
          : refEspecificaEmpresa.classList.remove("ed-is-invalid");
      }

      let tengoSegur = seguroNoCaduca
        ? true
        : fechaVencimiento !== "" &&
          !String(fechaVencimiento).includes("0001") &&
          fechaVencimiento !== null
          ? true
          : false;

      let especificarEmp = empresaSeguroArray.includes(8)
        ? especificarEmpresa.length > 3
        : empresaSeguroArray.length > 0;

      if (
        aceptoTerminos &&
        tengoSegur &&
        numeroPoliza !== "" &&
        numeroPoliza !== null &&
        especificarEmp &&
        bases64 !== "" &&
        bases64 !== null &&
        bases64 !== undefined &&
        nombreArchivo !== "" &&
        nombreArchivo !== null &&
        nombreArchivo !== undefined
      ) {
        let valoresRegistrar = {
          radioSeguros: seguro,
          empresaSeguro: Number(empresaSeguroArray),
          fechaVencimiento:
            fechaVencimiento == ""
              ? "2022-10-28T14:35:04.046904"
              : fechaVencimiento,
          numeroPoliza,
          nombreArchivo,
          aceptoTerminos,
          bases64,
          tipoArchivo,
          p_empresa_especificar: especificarEmpresa,
          p_cusuario: ndocidentidad,
          p_id_seguro: id_seguro,
          p_cnombrearchivo_anterior: cnombrearchivoAnterior,
          p_fvcto_nulo: seguroNoCaduca,
          // seguroNoCaduca
        };
        setMensaje({});
        try {
          setLoading(true);
          let seguroEstudiante = await update_seguroEstudiante(
            obtenerDatosEstudiante,
            valoresRegistrar
          );

          if (
            seguroEstudiante.StatusCode == 200 &&
            seguroEstudiante.Code == 1
          ) {
            let updatePaso = await update_paso(obtenerDatosEstudiante, 3, 1);
            if (updatePaso.StatusCode == 200 && updatePaso.Code == 1) {
              setCarritoHorario({ ntipos: seguro });

              let convertirPasoCompletadoMayoCero = Number(
                updatePaso.Data.paso_siguiente
              );
              let convertirPasoCompletado =
                convertirPasoCompletadoMayoCero > 0
                  ? convertirPasoCompletadoMayoCero - 1
                  : convertirPasoCompletadoMayoCero;
              setPasoProcesoM(convertirPasoCompletado);
            } else {
              throw updatePaso.Message;
            }
          } else {
            throw seguroEstudiante.Message;
          }
        } catch (error) {
          setLoading(false);
          let modalErrorr = document.querySelector("#modalErr");

          if (modalErrorr) {
            modalErrorr.click();
            setErrorCursoServices(error);
          }
        } finally {
          setLoading(false);
        }
      } else {
        setMensaje({ msj: `*${lbl_validacion_msj_todos_campos}.` });
      }
    }

    if (radioSeguros == "ConSeguro") {
      let valoresRegistrarSeguro = {
        radioSeguros: seguro,
        empresaSeguro: 0,
        fechaVencimiento: "2022-10-28T14:35:04.046904",
        numeroPoliza: 0,
        nombreArchivo: "",
        aceptoTerminos: false,
        bases64: "",
        tipoArchivo: "",
        p_empresa_especificar: "",
        p_cusuario: ndocidentidad,
        p_id_seguro: id_seguro,
        p_cnombrearchivo_anterior: cnombrearchivoAnterior,
        p_fvcto_nulo: seguroNoCaduca,
      };
      try {
        setLoading(true);
        let seguroEstudiante = await update_seguroEstudiante(
          obtenerDatosEstudiante,
          valoresRegistrarSeguro
        );

        if (
          seguroEstudiante.StatusCode == 200 &&
          seguroEstudiante.Code == 1
        ) {
          let updatePaso = await update_paso(obtenerDatosEstudiante, 3, 1);

          if (updatePaso.StatusCode == 200 && updatePaso.Code == 1) {
            setCarritoHorario({ ntipos: seguro });
            let convertirPasoCompletadoMayoCero = Number(
              updatePaso.Data.paso_siguiente
            );
            let convertirPasoCompletado =
              convertirPasoCompletadoMayoCero > 0
                ? convertirPasoCompletadoMayoCero - 1
                : convertirPasoCompletadoMayoCero;
            setPasoProcesoM(convertirPasoCompletado);
          } else {
            throw updatePaso.Message;
          }
        } else {
          throw seguroEstudiante.Message;
        }
      } catch (error) {
        setLoading(false);
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          setErrorCursoServices(error);
        }
      } finally {
        setLoading(false);
      }
    }
    // //radio 3
    if (radioSeguros == "vacio") {
      setMensajeRadio({ msj: `* Seleccione un seguro.` });
    }
  };

  const atrasBtnSeguro = async () => {
    //Primero validar
    try {
      setLoading(true);
      //Despues setear los campos de estado
      let updatePaso = await update_paso(obtenerDatosEstudiante, 1, 1);
      let convertirPasoCompletadoMayoCero = Number(
        updatePaso.Data.paso_siguiente
      );
      let convertirPasoCompletado =
        convertirPasoCompletadoMayoCero > 0
          ? convertirPasoCompletadoMayoCero - 1
          : convertirPasoCompletadoMayoCero;
      setPasoProcesoM(convertirPasoCompletado);

      // setPasoProcesoM(1);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (obtenerEmpresasSegurosAccidentes.length > 0) {
      const listEmpresas = formaterListEmpresaSeguro();
      setOption2(listEmpresas.slice(0, 7));
    }



  }, [obtenerEmpresasSegurosAccidentes]);

  const formaterListEmpresaSeguro = () => {

    const listEmpresas = obtenerEmpresasSegurosAccidentes.map((data) => ({
      name: data.nombre,
      code: data.id_empresa,
    }));
    return listEmpresas;
  };

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_msj_seguro: obtenerLabelEtiqueta(
          "lbl_global_msj_seguro",
          listadoEtiquetas
        ),
        seguro_msj_accidentes: obtenerLabelEtiqueta(
          "lbl_seguro_msj_accidentes",
          listadoEtiquetas
        ),
        seguro_msj_upch: obtenerLabelEtiqueta(
          "lbl_seguro_msj_upch",
          listadoEtiquetas
        ),
        seguro_msj_sis: obtenerLabelEtiqueta(
          "lbl_seguro_msj_sis",
          listadoEtiquetas
        ),
        seguro_msj_personal: obtenerLabelEtiqueta(
          "lbl_seguro_msj_personal",
          listadoEtiquetas
        ),
        seguro_togle_si: obtenerLabelEtiqueta(
          "lbl_seguro_togle_si",
          listadoEtiquetas
        ),
        seguro_togle_no: obtenerLabelEtiqueta(
          "lbl_seguro_togle_no",
          listadoEtiquetas
        ),
        seguro_empresa: obtenerLabelEtiqueta(
          "lbl_seguro_empresa",
          listadoEtiquetas
        ),
        seguro_seleccione: obtenerLabelEtiqueta(
          "lbl_seguro_seleccione",
          listadoEtiquetas
        ),
        global_nro_poliza: obtenerLabelEtiqueta(
          "lbl_global_nro_poliza",
          listadoEtiquetas
        ),
        global_fecha_vencimiento: obtenerLabelEtiqueta(
          "lbl_global_fecha_vencimiento",
          listadoEtiquetas
        ),
        seguro_seleccionar_archivo: obtenerLabelEtiqueta(
          "lbl_seguro_seleccionar_archivo",
          listadoEtiquetas
        ),
        seguro_descargar: obtenerLabelEtiqueta(
          "lbl_seguro_descargar",
          listadoEtiquetas
        ),
        seguro_msj_acepto_datos: obtenerLabelEtiqueta(
          "lbl_seguro_msj_acepto_datos",
          listadoEtiquetas
        ),
        seguro_archivo: obtenerLabelEtiqueta(
          "lbl_seguro_archivo",
          listadoEtiquetas
        ),
        msj_continuar: obtenerLabelEtiqueta(
          "lbl_seguro_msj_continuar",
          listadoEtiquetas
        ),
        msj_agregar_upch: obtenerLabelEtiqueta(
          "lbl_seguro_msj_agregar_upch",
          listadoEtiquetas
        ),

        reglamento_volver: obtenerLabelEtiqueta(
          "lbl_reglamento_volver",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
        lbl_validacion_msj_todos_campos: obtenerLabelEtiqueta(
          "lbl_validacion_msj_todos_campos",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    global_msj_seguro,
    seguro_msj_accidentes,
    seguro_msj_upch,
    seguro_msj_sis,
    seguro_msj_personal,
    seguro_togle_si,
    seguro_togle_no,
    seguro_empresa,
    seguro_seleccione,
    global_nro_poliza,
    global_fecha_vencimiento,
    seguro_seleccionar_archivo,
    seguro_descargar,
    seguro_msj_acepto_datos,
    seguro_archivo,
    msj_continuar,
    msj_agregar_upch,

    reglamento_volver,
    datos_continuar,
    lbl_validacion_msj_todos_campos,
  } = etiquetas;

  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <button
        id="bntPesoArchivoTipo"
        data-bs-toggle="modal"
        data-bs-target="#pesoArchivoTipo"
        style={{ display: "none" }}
      ></button>
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <form>
              <div className="form-body">
                <div className="matricula-title">
                  <h5 className="text-uppercase">{global_msj_seguro}</h5>
                  <div className="separator"></div>
                </div>

                {/* {validarSeguro === "0" && ( */}
                {validarSeguro === "0" && (
                  <>
                    <div className="mt-3 mb-4 btn-tienda">
                      <p className="mb-3 fw-bolder">
                        No cuento con seguro contra accidentes
                      </p>
                      <div className="d-flex flex-wrap">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm d-flex align-items-center btn-sm px-4 py-2 me-3"
                          style={{ lineHeight: 1, width: "fit-content" }}
                          onClick={handleShow}
                        >
                          <i className="bi bi-credit-card me-1 text-white d-flex align-items-center" />
                          Pagar seguro contra accidentes
                        </button>
                      </div>
                    </div>
                    <div className="my-3">
                      <div className="mt-4">
                        <div className="alert alert-warning" role="alert">
                          <p
                            className="mb-0"
                            style={{ lineHeight: "1.2", fontSize: 14 }}
                          >
                            <svg
                              viewBox="0 0 24 24"
                              style={{ width: 24, height: 24, marginRight: 5 }}
                            >
                              <path
                                fill="currentColor"
                                d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                              />
                            </svg>
                            Una vez realizado el pago del seguro contra
                            accidentes, esto puede tomar unos minutos en ser
                            detectado por el sistema. Puede dar clic en el botón
                            "Validar Pago del Seguro contra accidente" para
                            actualizar esta página y consultar el pago.
                          </p>

                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm px-4 mt-4"
                            onClick={validarSeguroUpch}
                          >
                            <i className="bi bi-arrow-clockwise text-upch me-1" />{" "}
                            Validar seguro contra accidentes
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="switch-assurance mb-4">
                  <label
                    className="form-check-label fw-bolder"
                    htmlFor="flexSwitchCheckChecked"
                  >
                    {seguro_msj_accidentes}
                  </label>

                  <label className="switch switch-blue">
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={toggles}
                      onChange={(e) => { }}
                    />
                    <span
                      className="switch-label"
                      data-on={seguro_togle_si && seguro_togle_si.toUpperCase()}
                      data-off={
                        seguro_togle_no && seguro_togle_no.toUpperCase()
                      }
                    ></span>
                    <span className="switch-handle"></span>
                  </label>
                </div>
                {toggles == true && (
                  <ul className="seguro">
                    <li className="mb-2">
                      <div className="form-check-inline">
                        {validarSeguro === "0" && (
                          <input
                            type="radio"
                            name="styles1"
                            id="box-shadow"
                            className="custom-radio upch-seguro form-check-input"
                            disabled
                          />
                        )}
                        {validarSeguro === "1" && (
                          <input
                            type="radio"
                            name="styles1"
                            id="box-shadow"
                            className="custom-radio upch-seguro form-check-input"
                            checked={radioSeguros == "ConSeguro" ? true : false}
                            onChange={(e) => {
                              setRadioSeguros(e.target.value);
                            }}
                            value="ConSeguro"
                          />
                        )}

                        <label className="text-black form-check-label px-1">
                          {seguro_msj_upch}
                        </label>
                      </div>
                    </li>

                    <li className="mb-2">
                      <div className="form-check-inline">
                        {validarSeguro === "1" && (
                          <input
                            type="radio"
                            name="styles"
                            disabled
                            id=""
                            className="custom-radio form-seguro form-check-input"
                          />
                        )}

                        {validarSeguro === "0" && (
                          <input
                            type="radio"
                            name="styles"
                            id=""
                            className="custom-radio form-seguro form-check-input"
                            value="SeguroPersonal"
                            checked={
                              radioSeguros == "SeguroPersonal" ? true : false
                            }
                            onChange={(e) => {
                              setRadioSeguros(e.target.value);
                            }}
                          />
                        )}

                        <label className="text-black form-check-label px-1">
                          {seguro_msj_personal}
                        </label>
                      </div>
                    </li>
                    <label className="control-label msjActualizacionDatos">
                      {mensajeRadio.msj}
                    </label>
                  </ul>
                )}

                {toggles == true && radioSeguros !== "vacio" && (
                  <div className="form-seguro seguro border rounded-3 mt-5  p-3">
                    <div className="d-flex row">
                      <div className="form-group col-sm-6 col-lg-3">
                        <label className="control-label">
                          {`${seguro_seleccione && seguro_seleccione} ${seguro_empresa && seguro_empresa.toLowerCase()
                            }`}
                        </label>
                        <SelectSeguro
                          option={formaterListEmpresaSeguro()}
                          option2={option2}
                          setOption2={setOption2}
                          selection={empresaSeguroArray || []}
                          setSelection={setEmpresaSeguroArray}
                          disableds={
                            radioSeguros === "ConSeguro" ? true : false
                          }
                          colorError={errorEmpresaSeguroArrayDom}
                          maxList={7}
                        />
                      </div>
                      {empresaSeguroArray.includes(8) && (
                        <div className="form-group col-sm-6 col-lg-3">
                          <label className="control-label">
                            Especificar Empresa:
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm especificaEmpresas"
                            placeholder="Empresa"
                            value={especificarEmpresa}
                            onChange={(e) => {
                              setEspecificarEmpresa(e.target.value);
                            }}
                          />
                        </div>
                      )}

                      <div className="form-group col-sm-6 col-lg-3">
                        <label className="control-label">
                          {global_nro_poliza}
                        </label>
                        <input
                          type="text"
                          autoComplete="off"
                          id="poliza"
                          disabled={radioSeguros === "ConSeguro" ? true : false}
                          className="form-control form-control-sm nroPoliza"
                          placeholder={global_nro_poliza}
                          value={
                            numeroPoliza == 0 || numeroPoliza == null
                              ? ""
                              : numeroPoliza
                          }
                          onChange={(e) => {
                            setNumeroPoliza(e.target.value);
                          }}
                          onKeyPress={(e) => soloLetras(e)}
                          onPaste={(e) => {
                            e.preventDefault();
                          }}
                        />
                      </div>
                      <div className="form-group col-sm-6 col-lg-3">
                        <label htmlFor="date" className="control-label">
                          {global_fecha_vencimiento}
                        </label>

                        <div
                          className="input-group input-group-sm date"
                          id="datepicker"
                        >
                          <DatePicker
                            selected={
                              String(fechaVencimiento).includes("0001")
                                ? ""
                                : fechaVencimiento
                            }
                            onChange={(date) => setFechaVencimiento(date)}
                            className="form-control form-control-sm fecha"
                            placeholderText="dd/mm/yyyy"
                            disabled={
                              radioSeguros === "ConSeguro" || seguroNoCaduca
                                ? true
                                : false
                            }
                            locale={idioma}
                            dateFormat="dd/MM/yyyy"
                          />

                          <span className="input-group-append">
                            <span className="input-group-text bg-light d-block">
                              <i className="fa fa-calendar"></i>
                            </span>
                          </span>
                        </div>

                        <div className="mt-2">
                          <input
                            type="checkbox"
                            checked={seguroNoCaduca}
                            onChange={(e) => {
                              setSeguroNoCaduca(e.target.checked);
                            }}
                            disabled={
                              radioSeguros === "ConSeguro" ? true : false
                            }
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor="flexCheckChecked"
                          >
                            Póliza no caduca
                          </label>
                        </div>
                      </div>
                      <div className="form-group col-sm-6 col-lg-3">
                        <label className="control-label">
                          {seguro_seleccionar_archivo}
                        </label>

                        <label
                          htmlFor="file"
                          className={`file archivo ${radioSeguros === "ConSeguro" && "disabled"
                            }`}
                        >
                          <svg
                            width="15"
                            height="16"
                            viewBox="0 0 15 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.08789 5.70625C3.4541 6.09656 4.04766 6.09687 4.41357 5.70628L6.5625 3.41563V11C6.5625 11.5522 6.98232 12 7.5 12C8.01768 12 8.4375 11.5522 8.4375 11V3.41563L10.5873 5.70875C10.9532 6.09906 11.5468 6.09906 11.913 5.70872C12.2789 5.31841 12.2789 4.68528 11.913 4.29466L8.16299 0.294656C7.98047 0.0976562 7.74023 0 7.5 0C7.25977 0 7.01953 0.0976562 6.83789 0.292969L3.08789 4.29375C2.72109 4.68437 2.72109 5.31563 3.08789 5.70625ZM14.0625 11H9.375C9.375 12.1047 8.53564 13 7.5 13C6.46436 13 5.625 12.1047 5.625 11H0.9375C0.419824 11 0 11.4478 0 12V15C0 15.5522 0.419824 16 0.9375 16H14.0625C14.5802 16 15 15.5522 15 15V12C15 11.4469 14.5811 11 14.0625 11ZM12.6562 14.25C12.2695 14.25 11.9531 13.9125 11.9531 13.5C11.9531 13.0875 12.2695 12.75 12.6562 12.75C13.043 12.75 13.3594 13.0875 13.3594 13.5C13.3594 13.9125 13.043 14.25 12.6562 14.25Z"
                              fill="#B80A28"
                            />
                          </svg>
                          &nbsp; {seguro_seleccionar_archivo}
                        </label>
                        {nombreArchivo !== "" &&
                          nombreArchivo !== null &&
                          nombreArchivo !== undefined && (
                            <small
                              className="text-file"
                              style={{ fontSize: ".67em", lineHeight: 1 }}
                            >
                              {seguro_archivo}: {formateoNombre(nombreArchivo)}
                            </small>
                          )}

                        <input
                          type="file"
                          name="file"
                          id="file"
                          ref={refSubirArchivo}
                          disabled={radioSeguros === "ConSeguro" ? true : false}
                          onChange={handleSubirArchivo}
                        />
                      </div>
                      {bases64 !== "" &&
                        bases64 !== null &&
                        bases64 !== undefined && (
                          <div className="form-group col-lg-2" id="down-file">
                            <label className="control-label text-white">
                              --- {seguro_descargar} ---
                            </label>
                            <a
                              href={`${bases64}`}
                              className="btn btn-primary btn-sm px-3 w-100"
                              target="_blank"
                              download={nombreArchivo}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  width: 12,
                                  height: 12,
                                  color: "white",
                                  fill: "white",
                                  verticalAlign: "baseline",
                                  marginRight: 5,
                                }}
                                viewBox="0 0 512 512"
                              >
                                <path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zM432 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z" />
                              </svg>
                              {seguro_descargar}
                            </a>
                          </div>
                        )}
                    </div>

                    <div className="mt-4">

                      <label className="container-checkbox">
                        {seguro_msj_acepto_datos}.
                        <input
                          type="checkbox"
                          checked={aceptoTerminos}
                          onChange={(e) => {
                            setAceptoTerminos(e.target.checked);
                          }}
                          disabled={radioSeguros === "ConSeguro" ? true : false}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    {mensaje.msj && (
                      <div className="form-group mt-4">
                        <label className="control-label msjActualizacionDatos">
                          {mensaje.msj}
                        </label>
                      </div>
                    )}
                  </div>
                )}
                {toggles == false && (
                  <div>
                    <p>{msj_continuar}</p>
                  </div>
                )}
              </div>
              {toggles == true && (
                <>
                  <button
                    type="button"
                    className="seguro btn waves-effect waves-light btn-light-secondary previous"
                    onClick={atrasBtnSeguro}
                  >
                    {reglamento_volver}
                  </button>

                  {radioSeguros == "SeguroPersonal" ||
                    radioSeguros == "vacio" ? (
                    statusDatosEstudianteSeguro == "200" ? (
                      <button
                        type="submit"
                        onClick={validarBtnTieneSeguro}
                        className="seguro btn waves-effect waves-light btn-primary next"
                      >
                        {datos_continuar}
                      </button>
                    ) : (
                      <button
                        disabled
                        className="seguro btn waves-effect waves-light btn-primary next"
                      >
                        {datos_continuar}
                      </button>
                    )
                  ) : (
                    <button
                      type="submit"
                      onClick={validarBtnTieneSeguro}
                      className="seguro btn waves-effect waves-light btn-primary next"
                    >
                      {datos_continuar}
                    </button>
                  )}
                </>
              )}
            </form>
            {toggles == false && (
              <div className="w-100 text-center mx-auto">
                <button
                  type="button"
                  className="btn btn-primary px-4 py-2"
                  style={{ lineHeight: 1 }}
                  data-bs-toggle="modal"
                  data-bs-target="#modalidad2"
                >
                  <svg
                    width={22}
                    height={18}
                    viewBox="0 0 22 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.6833 8.52351L11.6071 12.4102C11.3567 12.879 10.6316 12.8641 10.4021 12.3858L8.02915 7.44929L6.77707 10.252L2.68957 10.2501L10.0396 17.3673C10.5671 17.8778 11.4296 17.8778 11.9575 17.3673L19.3075 10.2501L14.6367 10.2503L13.6833 8.52351ZM19.6333 1.45554C17.3683 -0.379613 13.9042 -0.0483627 11.8208 1.9657L11 2.75984L10.1791 1.9657C8.09582 -0.0483627 4.63332 -0.379613 2.36707 1.45554C-0.0262645 3.39461 -0.298348 6.71882 1.50749 9.00008H5.88248L7.37957 5.63093C7.60907 5.12781 8.3654 5.11843 8.6104 5.61629L11.0358 10.671L13.0804 6.84285C13.3256 6.38386 14.0296 6.38386 14.275 6.84285L15.4279 9.00105H20.4904C22.3 6.71882 22.025 3.39461 19.6333 1.45554Z"
                      fill="white"
                    />
                  </svg>
                  &nbsp; {msj_agregar_upch}
                </button>
              </div>
            )}
          </fieldset>
        </div>
      </div>
      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      >
      </button>
      <ModalPagoSeguro
        show={show}
        handleClose={handleClose}
        handleSecondaryShow={handleSecondaryShow}
        showSecondary={showSecondary}
        handleSecondaryClose={handleSecondaryClose}
        showSecondaryPayment={showSecondaryPayment}
        seguroDatos={seguroDatos}
        handleShowModalRequest={handleShowModalRequest}
        listDatosPersonalesPreli={{
          preliquidacion: preliquidacion,
          datosPersonales: datosPersonales,
        }}
        onPagoExitoso={validarSeguroUpch}
      />

      <ModalSuccesErrorPasarela
        inputsShowTypes={requestPasarela}
        handleClose={handleCloseModalRequest}
      />
    </div>
  );
};

export default Seguro;